export default "__VITE_ASSET__CCj2PQZg__"